import { Link } from 'react-router-dom';

type Props = { texto: string; titulo?: string };

export default function PacotesBox({ texto, titulo = 'Economia com previsibilidade' }: Props) {
  return (
    <section className="py-12 md:py-16 bg-white dark:bg-gray-900">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        <div className="rounded-3xl bg-secondary text-white p-8 md:p-10">
          <p className="font-body text-primary font-semibold text-sm uppercase tracking-widest mb-3">Pacotes mensais e pacotes de eventos</p>
          <h2 className="font-heading font-bold text-2xl md:text-3xl mb-4">{titulo}</h2>
          <p className="font-body text-white/85 leading-relaxed mb-4">{texto}</p>
          <ul className="font-body text-white/85 space-y-2 mb-6">
            <li>• Valor fechado: orçamento previsível para o mês ou para o calendário de eventos.</li>
            <li>• Economia em relação à contratação avulsa, evento a evento.</li>
            <li>• Fones e equipe reservados nas suas datas.</li>
          </ul>
          <Link to="/orcamento" className="inline-block font-body font-semibold bg-primary text-secondary px-6 py-3 rounded-full hover:opacity-90 transition-opacity">Quero um pacote</Link>
        </div>
      </div>
    </section>
  );
}
